export function set (context, n) {
  context.commit('set', n)
}

export function clear (context, n) {
  context.commit('clear', n)
}

